const React = require('react');

const BgWrapper = ({children}) => (
  <div className="bgF6F6F6 r9">{children}</div>
);

const TransparentWrapper = ({children}) => (
  <div className="bb1 bsbSolid bcbDADCE1">{children}</div>
);

module.exports = ({title, value, isTransparent}) => {
  const Wrapper = isTransparent ? TransparentWrapper : BgWrapper;
  return (
    <Wrapper>
      <div className="pt20 ph26 pb19">
        <span className="dB f12 fw4 lh18">
          {title}
        </span>
          <span className="dB mt3 f23 fw7 lh34">
          {value}
        </span>
      </div>
    </Wrapper>
  )
}